import { AssignmentSourceActivity } from 'Services/Api/AssignmentSources/Types';

/**
 * Resolves the course id an assignment-source activity points at.
 *
 * Responses return the reference as `id` while create/update payloads use
 * `activity_id`, so read through this instead of picking one key.
 */
export const assignmentActivityId = (
	activity: AssignmentSourceActivity
): number | undefined => activity.activity_id ?? activity.id;

/** Course ids referenced by an assignment source's activities, deduped. */
export const assignmentActivityIds = (
	activities: AssignmentSourceActivity[]
): number[] => [
	...new Set(
		activities
			.map(assignmentActivityId)
			.filter((id): id is number => typeof id === 'number')
	)
];
